export default (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 17 18"
    fill="none"
    {...props}
  >
    <circle
      cx="7.3136"
      cy="7.86829"
      r="6.55892"
      stroke="#5E6366"
      strokeWidth="1.4"
    />
    <path
      d="M15.2187 17.0883C15.4839 17.3696 15.9269 17.3826 16.2082 17.1174C16.4895 16.8522 16.5025 16.4092 16.2373 16.1279L15.2187 17.0883ZM11.2016 12.8279L15.2187 17.0883L16.2373 16.1279L12.2202 11.8674L11.2016 12.8279Z"
      fill="#5E6366"
    />
    <rect
      x="6.66406"
      y="4.42969"
      width="1.3"
      height="6.88"
      rx="0.65"
      fill="#5E6366"
    />
    <rect
      x="10.7539"
      y="7.21875"
      width="1.3"
      height="6.88"
      rx="0.65"
      transform="rotate(90 10.7539 7.21875)"
      fill="#5E6366"
    />
  </svg>
);
